module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAE6SURBVDhPY0hPT18cGhrKzEApSE1NPRgfH68A5ZIPUlJSkoF4ApRLPrC3t2cBuuoHiJ2bm8uelZXFQwoGGwIDQIOup6Wl7QLiT0D2axLxQ2A4S4MNAhoQA+R8AHNIBECDHIH6Z0C5YIFfUCZJAOiAMiAuhHLBrnpfVFQkAuUSDUD6YmNjhaFcsMlZQMF6KJdoAPTJSygTAkAxABQ8C+USBYCWWwP1rIdyIaC+vp4J6KLvUC5RAKj+YkZGhg6UiwBAic1AG+yhXIIAqBac/jAA0Hs2QMMOAPMeG1QIJ4CG6X4oFwMwAhVUggIQiE/jwkADbgPVHQQGBwtUH3YAyipAzIcLx8TEcAOVMUJU4wFA2xKAtm6FclEAUM4fGMArgUzCBgENmQ/0Amr6gAKgeC9Q/jEQs0KFgICBAQA4O6YnH1r3eQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/img/3.png
// module id = 82
// module chunks = 0